import MyTabs from '../../components/MyTabs';
import ResearchCategories from './ResearchCategories/ResearchCategories';
import Keywords from './Keywords/Keywords';
import Dimensions from './Dimensions/Dimensions';
import Section1 from './Section1/Section1';
import Section2 from './Section2/Section2';
import Section3 from './Section3/Section3';
import Section4 from './Section4/Section4';
import BookInfo from './BookInfo/BookInfo';
import AuctionInfo from './AuctioInfo/AuctionInfo';
import { useParams } from 'react-router-dom';

const GeneralLibraries = () => {

    const { alias } = useParams();


    const isTabDisabled = alias ? false : true;

    const tabs = [
        { id: "section1", title: "Section-1", Component: Section1},
        { id: "section2", title: "Section-2", Component: Section2, isDisabled: isTabDisabled  },
        { id: "section3", title: "Section-3", Component: Section3, isDisabled: isTabDisabled  },
        { id: "section4", title: "Section-4", Component: Section4, isDisabled: isTabDisabled  },
        { id: "book-info", title: "Book Info", Component: BookInfo, isDisabled: isTabDisabled },
        { id: "auction-info", title: "Auction Info", Component: AuctionInfo, isDisabled: isTabDisabled },
        { id: "researchCategories", title: "Research Categories", Component: ResearchCategories, isDisabled: isTabDisabled  },
        { id: "keywords", title: "Keywords", Component: Keywords, isDisabled: isTabDisabled  },
        { id: "dimensions", title: "Dimensions", Component: Dimensions, isDisabled: isTabDisabled  },
      ];

    return (
        <>
            <MyTabs list={tabs}/>
        </>
    )
};

export default GeneralLibraries;